import { AppBar, Container, Stack, Typography } from "@mui/material";
import React from "react";

import { IgniteLogo } from "../IgniteLogo";

interface Props {
    appBar?: boolean;
    appBarTitle?: string;
    topBar?: React.ReactNode;
    children?: React.ReactNode;
}

const Layout: React.FC<Props> = ({ appBar, appBarTitle, topBar, children }) => {
    return (
        <Stack minHeight="100vh" sx={{ backgroundColor: "background.backgroundSecondary" }}>
            {appBar && (
                <AppBar
                    position="sticky"
                    elevation={0}
                    sx={{
                        backgroundColor: "background.paper",
                        paddingY: { xs: 1, md: 2 },
                        paddingX: 4.5,
                    }}
                >
                    {appBarTitle ? (
                        <Stack alignItems="center" direction="row" justifyContent="center" width="100%">
                            <Typography variant="textMd" fontWeight={500} color="textTextPrimary">
                                {appBarTitle}
                            </Typography>
                        </Stack>
                    ) : (
                        <Stack alignItems="flex-start" direction="row" justifyContent="space-between" width="100%">
                            <IgniteLogo size="small" />
                        </Stack>
                    )}
                </AppBar>
            )}
            {topBar}
            <Container maxWidth="md" sx={{ minHeight: "300px" }} disableGutters={false}>
                {children}
            </Container>
        </Stack>
    );
};

export default Layout;
